<template>
    <b-container fluid>
        <h1 class="text-left">{{ title }}</h1>
        <br />
        <b-form
            ref="nedbrowserForm"
            class="col-xs-12 col-lg-9 pb-5"
            name="nedbrowserForm"
            v-on:submit.prevent="$_onSubmit"
        >
            <b-form-group
                id="fieldset-1"
                :description="description"
                :label="text"
                :label-for="name"
                :label-class="labelClass"
                :label-size="labelSize"
            >
                <div :id="`input_${name}`" class="import-group">
                    <div class="import-control" v-on:click="$_selectFile">
                        <em class="fas fa-plus-circle import-icon"></em>
                        <span :id="`selected_${name}`" class="import-name">{{
                            fileName
                        }}</span>
                    </div>
                    <!-- Invisible file selector -->
                    <input
                        v-bind="$attrs"
                        ref="fileSelector"
                        v-show="false"
                        type="file"
                        accept=".zip"
                        :id="name"
                        :name="name"
                        :value="value"
                        @change="$_onChange"
                        :data-fieldname="name"
                    />
                </div>
            </b-form-group>
            <b-form-group>
                <!-- NedBrowser Previous imports -->
                <b-container fluid class="mt-3">
                    <div>
                        <h3 class="text-left">{{ previousImportsText }}</h3>
                        <b-table
                            id="table-previous-imports"
                            ref="importsTable"
                            small
                            hover
                            outlined
                            bordered
                            selectable
                            responsive
                            :per-page="perPage"
                            :current-page="previousImportsPage"
                            :select-mode="'single'"
                            :tbody-tr-class="$_rowClass"
                            :items="importedFiles"
                            :fields="importedFileFields"
                            @row-selected="$_importResultSelected"
                            sort-icon-left
                        >
                        </b-table>
                        <p>{{ $t('nedbrowser.selectMessage') }}</p>
                        <b-pagination
                            v-model="previousImportsPage"
                            :total-rows="previousImportsRows"
                            :per-page="perPage"
                            aria-controls="my-table"
                        >
                        </b-pagination>
                    </div>
                </b-container>
                <!-- NedBrowser Import result -->
                <b-container fluid class="mt-3" v-show="showImportResult">
                    <div v-show="importResults.length > 0">
                        <h3 class="text-left">{{ importResultTitle }}</h3>
                        <b-table
                            id="table-warnings-1"
                            striped
                            small
                            outlined
                            bordered
                            :tbody-tr-class="$_rowClass"
                            :items="importResults"
                            :fields="importResultFields"
                            sort-icon-left
                        >
                        </b-table>
                    </div>
                </b-container>
                <!-- NedBrowser Check warnings -->
                <b-container fluid class="mt-3" v-show="showCheckErrors">
                    <div v-show="warningTables.length > 0">
                        <h3 class="text-left import-error">
                            {{ $t('nedbrowser.warningLayers') }}
                        </h3>
                        <b-table
                            id="table-warnings-1"
                            striped
                            outlined
                            bordered
                            small
                            :tbody-tr-class="$_rowClass"
                            :items="warningTables"
                            :fields="tableWarningFields"
                            sort-icon-left
                        >
                        </b-table>
                    </div>
                    <div v-show="warningSlds.length > 0">
                        <h3 class="text-left">
                            {{ $t('nedbrowser.warningSlds') }}
                        </h3>
                        <b-table
                            id="table-warnings-2"
                            striped
                            outlined
                            bordered
                            small
                            :tbody-tr-class="$_rowClass"
                            :items="warningSlds"
                            :fields="sldWarningFields"
                            sort-icon-left
                        >
                        </b-table>
                    </div>
                    <div v-show="warningSldErrors.length > 0">
                        <h3 class="text-left import-error">
                            {{ $t('nedbrowser.warningSldSyntax') }}
                        </h3>
                        <b-table
                            id="table-warnings-3"
                            striped
                            outlined
                            bordered
                            small
                            :tbody-tr-class="$_rowClass"
                            :items="warningSldErrors"
                            :fields="styleWarningFields"
                            sort-icon-left
                        >
                        </b-table>
                    </div>
                </b-container>
                <!-- NedBrowser Import errors -->
                <b-container fluid class="mt-3" v-show="showImportErrors">
                    <div>
                        <h3 class="text-left import-error">
                            {{ $t('nedbrowser.importErrors') }}
                        </h3>
                        <b-table
                            id="table-warnings-1"
                            striped
                            small
                            outlined
                            bordered
                            :tbody-tr-class="$_rowClass"
                            :items="importErrors"
                            :fields="importErrorFields"
                            sort-icon-left
                        >
                        </b-table>
                    </div>
                </b-container>
                <!-- NedBrowser Import exceptions -->
                <b-container fluid class="mt-3" v-show="showImportExceptions">
                    <div>
                        <h3 class="text-left import-error">
                            {{ $t('nedbrowser.importExceptions') }}
                        </h3>
                        <b-table
                            id="table-warnings-1"
                            striped
                            small
                            outlined
                            bordered
                            :tbody-tr-class="$_rowClass"
                            :items="importExceptions"
                            :fields="importExceptionFields"
                            sort-icon-left
                        >
                        </b-table>
                    </div>
                </b-container>
                <!-- Import progress -->
                <b-container
                    fluid
                    class="mt-3"
                    v-show="importProgressMessage.length > 0"
                >
                    <div>
                        <br />
                        <h3 class="text-left">
                            {{
                                $t('nedbrowser.importStatus', [pollingFileName])
                            }}
                        </h3>
                        {{ importProgressMessage }}
                    </div>
                </b-container>
            </b-form-group>
            <!-- OWS add / cancel buttons -->
            <submit-cancel-remove
                :save-label="'btnImportLabel'"
                :is-saving="isSaving"
                :is-deleting="isDeleting"
                :mode="mode"
                @cancel="$_onCancel"
                :isBtnSaveDisabled="isBtnSaveDisabled"
                :is-disabled="false"
            >
            </submit-cancel-remove>
        </b-form>
    </b-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { nprogress } from '../../services/utilities';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import SubmitCancelRemove from '../../components/SubmitCancelRemove.vue';

    export default {
        name: 'NedBrowserImport',

        mixins: [modalMixin],

        props: {
            description: { type: String, required: false },
            name: { type: String, required: false, default: 'nedbrowser-import' },
            labelSize: { type: String, required: false, default: '' },
            value: [String, Number],
            labelClass: { type: String, default: 'font-weight-normal' }
        },

        components: { 'submit-cancel-remove': SubmitCancelRemove },

        data() {
            return {
                title: this.$t('nedbrowser.importTitle'),
                fileName: 'Geen bestand gekozen',
                text: this.$t('nedbrowser.fileSelectTitle'),
                isSaving: false,
                isDeleting: false,
                mode: 0,
                isBtnSaveDisabled: true,
                importData: null,
                // polling for import status
                pollingId: -1,
                pollingFileName: '',
                importProgressMessage: '',
                showImportedFiles: false,
                importedFiles: [],
                importedFileFields: [
                    {
                        key: 'userName',
                        label: this.$t('nedbrowser.userName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'fileName',
                        label: this.$t('nedbrowser.fileName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'startDateTime',
                        label: this.$t('nedbrowser.startDateTime'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'endDateTime',
                        label: this.$t('nedbrowser.endDateTime'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'status',
                        label: this.$t('nedbrowser.status'),
                        sortable: false,
                        thStyle: { border: 0 }
                    }
                ],
                // paging
                perPage: 7,
                previousImportsPage: 1,

                showCheckErrors: false,
                checkErrorsTitle: '',
                warningTables: [],
                warningSlds: [],
                warningSldErrors: [],
                tableWarningFields: [
                    {
                        key: 'layerName',
                        label: this.$t('nedbrowser.columnLayerName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'tableName',
                        label: this.$t('nedbrowser.columnTableName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    }
                ],

                sldWarningFields: [
                    {
                        key: 'layerName',
                        label: this.$t('nedbrowser.columnLayerName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'sldName',
                        label: this.$t('nedbrowser.columnSldName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    }
                ],

                styleWarningFields: [
                    {
                        key: 'layerName',
                        label: this.$t('nedbrowser.columnLayerName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'sldName',
                        label: this.$t('nedbrowser.columnSldName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'message',
                        label: this.$t('nedbrowser.columnError'),
                        sortable: false,
                        thStyle: { border: 0 }
                    }
                ],

                importResultTitle: '',
                showImportResult: false,
                importResults: [],
                importResultFields: [
                    {
                        key: 'tableName',
                        label: this.$t('nedbrowser.columnTableName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'layerName',
                        label: this.$t('nedbrowser.columnLayerName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'sldName',
                        label: this.$t('nedbrowser.columnStyleName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    }
                ],

                showImportErrors: false,
                importErrors: [],
                importErrorFields: [
                    {
                        key: 'tableName',
                        label: this.$t('nedbrowser.columnTableName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'layerName',
                        label: this.$t('nedbrowser.columnLayerName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'sldName',
                        label: this.$t('nedbrowser.columnStyleName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'message',
                        label: this.$t('nedbrowser.columnError'),
                        sortable: false,
                        thStyle: { border: 0 }
                    }
                ],

                showImportExceptions: false,
                importExceptions: [],
                importExceptionFields: [
                    {
                        key: 'typeError',
                        label: this.$t('nedbrowser.columnFatalErrorType'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'message',
                        label: this.$t('nedbrowser.columnFatalErrorMessage'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'context',
                        label: this.$t('nedbrowser.columnFatalErrorContext'),
                        sortable: false,
                        thStyle: { border: 0 }
                    }
                ],

                previousImportsText: this.$t('nedbrowser.previousImportsMessage')
            };
        },

        G1Count: 0,

        computed: {
            ...mapGetters(['getUserInfo', 'getLocale']),

            userInfo() {
                return this.getUserInfo;
            },

            previousImportsRows() {
                return this.importedFiles.length;
            }
        },

        async mounted() {
            // Retrieve Language codes
            // this.$_initializeWebJobStatuses();
            await this.$_showImports();
            // Start get messages loop
            this.pollingId = setInterval(await this.$_showProgress, 2500, this);
        },

        methods: {
            $_rowClass() {
                return 'tablerow';
            },

            /**
             * File selected event handler
             * @param  {object} event [holds the selected files]
             */
            $_onChange(event) {
                this.$_resetErrorAndWarnings();

                const files = event.currentTarget.files;
                if (files.length > 0) {
                    this.fileName = files[0].name;
                    // read file content
                    this.readFileContent(files).then(
                        (result) => {
                            this.importData = result.data;
                            this.isBtnSaveDisabled = false;
                        },
                        (error) => {
                            const data = {
                                message: this.$t(error.message),
                                variant: 'danger',
                                title: this.$t('nedbrowser.fileTypeError'),
                                autoHideDelay: 10000
                            };
                            this.showToast(data);
                            this.isSaving = false;
                        }
                    );
                } else {
                    this.fileName = 'Geen bestand gekozen';
                }
            },

            $_initializeWebJobStatuses() {
                // Retrieve available languages
                this.getRefCodes('WEBJOB_STATUS').then((result) => {
                    for (const webJobStatus of result.data) {
                        this.webJobStatuses.push({
                            code: webJobStatus.code,
                            description: webJobStatus.description
                        });
                    }
                });
            },

            /**
             * Show the import file selector
             */
            $_selectFile() {
                // call click on the hidden file selector
                this.$refs.fileSelector.click();
            },

            /**
             * Read the zip content
             * @param  {Array} files   [selected zip files]
             * @return {object}        [Promise object]
             */
            readFileContent(files) {
                return new Promise((resolve, reject) => {
                    // het geselecteerde zip bestand
                    const file = files[0];
                    if (file && file.size > 20971520) {
                        reject(new Error('Bestand is te groot'));
                        return;
                    }

                    try {
                        // read file
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            const data = e.target.result.split(',')[1];
                            const type = e.target.result.split(';')[0];
                            // result
                            resolve({
                                data,
                                type
                            });
                        };
                        reader.readAsDataURL(file);
                    } catch (error) {
                        reject(error);
                    }
                });
            },

            $_resetErrorAndWarnings() {
                this.showCheckErrors = false;
                this.showImportResult = false;
                this.showImportResult = false;
                this.showImportErrors = false;
                this.showImportExceptions = false;

                this.warningTables = [];
                this.warningSlds = [];
                this.warningSldErrors = [];
                this.importResults = [];
                this.importErrors = [];
                this.importExceptions = [];
            },

            async $_showImports() {
                nprogress.start();
                try {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetNedBrowserImports'
                    });
                    this.importedFiles = result.data;

                    this.importedFiles.forEach((item, index) => {
                        if (item.status.startsWith('G1')) {
                            item.status = this.$t('nedbrowser.importQueued');
                        } else if (item.status.startsWith('I1')) {
                            item.status = this.$t('nedbrowser.importProgress');
                        } else if (item.status === 'I2') {
                            item.status = this.$t('nedbrowser.importSuccess');
                        } else if (item.status === 'I3') {
                            item.status = this.$t('nedbrowser.importWarning');
                        } else if (item.status === 'I4') {
                            item.status = this.$t('nedbrowser.importError');
                        }

                        let date = new Date(item.startDateTime);
                        item.startDateTime = date.toLocaleString(this.getLocale);
                        date = new Date(item.endDateTime);
                        item.endDateTime = date.toLocaleString(this.getLocale);
                    });

                    this.showImportedFiles = true;
                } finally {
                    nprogress.done();
                    // select the first row
                    if (this.importedFiles.length > 0) {
                        this.$refs.importsTable.selectRow(0);
                    }
                }
            },

            async $_showProgress(self) {
                const result = await self.$store.dispatch('useApiData', {
                    name: 'GetNedBrowserImportStatus'
                });
                if (!result.data || result.data.length === 0) {
                    clearInterval(self.pollingId);
                    self.pollingId = -1;
                    return;
                }

                this.pollingFileName = result.data.fileName;
                if (
                    result.data.status === 'I2' ||
                    result.data.status === 'I3' ||
                    result.data.status === 'I4'
                ) {
                    clearInterval(self.pollingId);
                    self.pollingId = -1;
                    self.importProgressMessage = '';
                    // refresh imported list
                    await self.$_showImports();
                } else {
                    if (result.data.status === 'G1') {
                        this.G1Count++;
                        self.importProgressMessage = self.$t(
                            'nedbrowser.importQueued'
                        );
                    } else {
                        const tokens = result.data.status.split(':');

                        if (tokens.length > 1) {
                            self.importProgressMessage = self.$t(
                                'nedbrowser.importProgressLayer',
                                [tokens[1]]
                            );
                        } else {
                            self.importProgressMessage = self.$t(
                                'nedbrowser.importProgress'
                            );
                        }
                    }
                }
                // stop polling after G1Count > 20
                if (this.G1Count > 20) {
                    this.G1Count = 0;
                    clearInterval(self.pollingId);
                    self.pollingId = -1;
                    self.importProgressMessage = '';
                    // show warning
                    const message = this.$t('nedbrowser.startProcessingDelayed', [
                        this.pollingFileName
                    ]);
                    this.showToast({
                        title: null,
                        message: message,
                        variant: 'warning',
                        autoHideDelay: 5000
                    });
                }
            },

            async $_importResultSelected(rowData) {
                // reset previous selection
                this.$_resetErrorAndWarnings();
                this.importProgressMessage = '';

                if (rowData && rowData.length > 0) {
                    nprogress.start();
                    try {
                        this.G1Count = 0;
                        // get import result data
                        const result = await this.$store.dispatch('useApiData', {
                            name: 'GetNedBrowserImportResult',
                            parameters: { Id: rowData[0].id }
                        });
                        // titles
                        this.checkErrorsTitle = this.$t('nedbrowser.checkErrors', [
                            result.data.fileName
                        ]);
                        this.importResultTitle = this.$t(
                            'nedbrowser.importResult',
                            [result.data.fileName]
                        );

                        // warnings and errors
                        if (
                            result.data.checkReport &&
                            result.data.checkReport.length > 0
                        ) {
                            const checkReport = JSON.parse(
                                result.data.checkReport ?? ''
                            );
                            this.warningTables = checkReport.filter(
                                (r) => r.context === 'PostGIS table not found'
                            );
                            this.warningSlds = checkReport.filter(
                                (r) => r.context === 'SldNotFound'
                            );
                            this.warningSldErrors = checkReport.filter(
                                (r) => r.context === 'Sld syntax error'
                            );
                            this.showCheckErrors =
                                this.warningTables.length > 0 ||
                                this.warningSlds.length > 0 ||
                                this.warningSldErrors.length > 0;
                        }

                        // imported layers
                        if (
                            result.data.importReport &&
                            result.data.importReport.length > 0
                        ) {
                            const importReport = JSON.parse(
                                result.data.importReport
                            );
                            this.importResults = importReport.filter(
                                (r) => r.type === 'ImportedLayer'
                            );
                            this.showImportResult = this.importResults.length > 0;
                            // import errors
                            this.importErrors = importReport.filter(
                                (r) => r.type === 'Error'
                            );
                            this.showImportErrors = this.importErrors.length > 0;
                            // import exceptions
                            this.importExceptions = importReport.filter(
                                (r) => r.type === 'Exception'
                            );
                            this.showImportExceptions =
                                this.importExceptions.length > 0;
                        }
                    } finally {
                        nprogress.done(this.importResults);
                    }
                }
            },

            async $_isImportFileProcessing(filename) {
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetIsImportFileProcessing',
                    parameters: { Filename: filename }
                });
                return result.data;
            },

            /**
             * Check selected zip file
             * @return {[type]} [description]
             */
            async $_onSubmit() {
                this.$_resetErrorAndWarnings();

                try {
                    const filename = this.fileName;
                    this.isSaving = true;

                    if (!this.importData) {
                        return;
                    }
                    // check if selected import file is being processed.
                    // Importing the same import file in parallel does not make GeoServer happy.
                    if (await this.$_isImportFileProcessing(filename)) {
                        const message = this.$t('nedbrowser.processingThisFile', [
                            filename
                        ]);
                        this.showToast({
                            title: null,
                            message: message,
                            variant: 'warning',
                            autoHideDelay: 5000
                        });
                        this.isBtnSaveDisabled = true;
                        // reload list with imported files
                        await this.$_showImports();
                        return;
                    }

                    nprogress.start();
                    // import selected zip file
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'NedBrowserImport',
                        data: { filename, data: this.importData },
                        config: { timeout: 0 }
                    });

                    if (result.data.isQueued) {
                        // show progress
                        this.pollingId = setInterval(
                            await this.$_showProgress,
                            2500,
                            this
                        );
                        // show info to the user
                        const message = this.$t('nedbrowser.queuedImport');
                        this.showToast({
                            title: null,
                            message: message,
                            variant: 'success',
                            autoHideDelay: 5000
                        });
                        // reload list with imported files
                        await this.$_showImports();
                    }
                    this.isBtnSaveDisabled = true;
                } catch (error) {
                    this.importResult = true;
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        title: this.$t('nedbrowser.errorImport'),
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                } finally {
                    nprogress.done();
                    this.isSaving = false;
                    this.fileName = 'Geen bestand gekozen';
                }
            },

            /**
             * Cancel NedBrowser layer import
             */
            $_onCancel() {
                this.$router.push({ path: '/' });
            }
        }
    };
</script>

<style lang="scss" scoped>
.import-group {
    display: block;
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
}

.import-control {
    background: #fff;
    cursor: pointer;
    border-radius: 0.25rem;
}

.import-icon {
    color: #007ac9;
    margin-left: 10px;
}

.import-title {
    margin-left: 10px;
    margin-right: 10px;
}

.import-name {
    margin-left: 10px;
    margin-right: 15px;
}

.import-error {
    color: red !important;
}
</style>
